<template>
  <div class="c-content-carousel">
    <div class="c-content-carousel__wrapper" :class="{'c-content-carousel__wrapper--px': showNav && items.length > 1}">
      <div v-show="showNav && items.length > 1" class="c-content-carousel__nav">
        <VButton
          extra-class="c-content-carousel__nav-item c-content-carousel__nav-item--prev"
          :aria-label="labelPrevious"
          @click.native="carousel.prev()"
        >
          <span class="c-content-carousel__nav-icon" />
        </VButton>
      </div>

      <div class="c-content-carousel__carousel" ref="carousel">
        <slot />
      </div>

      <div v-show="showNav && items.length > 1" class="c-content-carousel__nav">
        <VButton
          extra-class="c-content-carousel__nav-item c-content-carousel__nav-item--next"
          :aria-label="labelNext"
          @click.native="carousel.next()"
        >
          <span class="c-content-carousel__nav-icon" />
        </VButton>
      </div>
    </div>
    <div v-show="showIndicators && items.length > 1" class="c-content-carousel__indicators">
      <VButton
        v-for="(item, i) in items"
        :key="i"
        :aria-label="`${labelIndicators} ${item.title || i + 1}`"
        :extra-class="`c-content-carousel__indicator ${currentSlide === i ? 'c-content-carousel__indicator--active' : ''}`"
        @click.native="carousel.goTo(i)"
      />
    </div>
  </div>
</template>

<script>
import Siema from 'siema'
import VButton from '@forlagshuset/v-button'

import autoHeight from './src/autoHeight'

export default {
  name: 'content-carousel',

  data() {
    return {
      carousel: null,
      currentSlide: 0,
      items: []
    }
  },

  components: {
    VButton
  },

  props: {
    showIndicators: {
      type: Boolean,
      default: true
    },
    autoHeight: {
      type: Boolean,
      default: false
    },
    showNav: {
      type: Boolean,
      default: true
    },
    options: {
      type: Object,
      default: () => {}
    },
    labelPrevious: {
      type: String,
      default: 'Previous'
    },
    labelNext: {
      type: String,
      default: 'Next'
    },
    labelIndicators: {
      type: String,
      default: 'Go to'
    }
  },

  mounted() {
    const optionsMerge = Object.assign(
      {},
      {
        selector: this.$refs.carousel,
        onInit: () => {
          if (!this.carousel) return
          this.currentSlide = this.carousel.currentSlide
          this.$emit('init')
        },
        onChange: () => {
          if (!this.carousel) return
          this.currentSlide = this.carousel.currentSlide
          if (this.autoHeight) autoHeight(this.carousel)
          this.$emit('change')
        },
      },
      this.options
    )
    this.items = this.$slots.default

    if (this.items.length) {
      this.carousel = new Siema(optionsMerge)
    }
  }
}
</script>

<style lang="scss">
.c-content-carousel__wrapper {
  display: block;
  position: relative;
  padding-left: 4em;
  padding-right: 4em;
}

.c-content-carousel__nav {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.c-content-carousel__nav-item {
  position: absolute;

  width: 2.5em;
  height: 2.5em;
  padding: 0;
  background: #ccc;
  border-radius: 50%;
  top: 50%;
  transform: translateY(-50%);

  &:hover {
    background: rgba(#ccc, 0.75);
  }

  &--prev {
    margin-right: 1em;
    left: 0;
  }

  &--next {
    margin-left: 1em;
    right: 0;
  }
}

.c-content-carousel__nav-icon {
  border: solid #000;
  border-width: 0 3px 3px 0;
  display: inline-block;
  padding: 3px;

  .c-content-carousel__nav-item--next & {
    transform: rotate(-45deg);
    margin-right: 3px;
  }

  .c-content-carousel__nav-item--prev & {
    transform: rotate(135deg);
    margin-left: 3px;
  }
}

.c-content-carousel__indicators {
  margin-top: 1.5em;
  text-align: center;
}

.c-content-carousel__indicator {
  width: 1.25em;
  height: 1.25em;
  padding: 0;
  background: #ccc;
  margin: 0 0.5em;
  border-radius: 50%;

  &:hover {
    background: rgba(#ccc, 0.75);
  }

  &--active {
    background: #7D91F9;

    &:hover {
      background: rgba(#7D91F9, 0.75);
    }
  }
}
</style>
